export const j_ob = {
    "ls": [
        "termfolio: Whatever you're watching rn lol",
        "nvim-configs: My neovim configuration files",
        "IIITD-ResumeLatexTemplate: A template to create your resume (IIITD)",
        "ConflictResolutionVault: A blockchain based trustless conflict resolution",
        "MNIST_CAELatentSpace: An EDA on latent space of Convolutional Autoencoder",
        "dbms-PROject: A full fledged banking system",
        "fun_OS: All my OS code",
        "rerebot: A discord bot for none of your needs",
        "CO_M21_Assignment: An assembler/parser and simulator",
        "Genalgo_py: A simple genetic algorithm implementation",
        "CJ8-blessed-badgers: A zelda game made just for terminal",
        "JEEmain_selfevaluation: A script for self-evaluation on JEE papers",
        "Image-correlation: An open-cv based object correlation model",
        "cellular_automata1D: A generalized automata for 1 dimension",
        "Digit-Classifier-100p: A MATLAB based Machine learning hello world",
        "text-encryption: Whatever the name is xD"
    ]
}